// Score Movement: the lists its address can open. No React in here.
import type { DashboardListInfo } from './types';

export type ScoreMovementList = 'still-falling' | 'improved' | 'declined' | 'scored';

/**
 * Every list on Score Movement that can be opened by address. All four are about the
 * latest scored month, which can be earlier than the month picked.
 */
export const LISTS: Array<DashboardListInfo & { slug: ScoreMovementList }> = [
  {
    slug: 'still-falling',
    name: 'Still falling',
    line: 'People whose score has dropped three months in a row.',
    keywords: 'keeps falling declining streak',
  },
  { slug: 'improved', name: 'Improved', line: 'People who scored a point or more higher than the month before.' },
  { slug: 'declined', name: 'Declined', line: 'People who scored a point or more lower than the month before.' },
  { slug: 'scored', name: 'Employees scored', line: 'Everyone with a score in the latest scored month.' },
];

export const scoreMovementListFromSlug = (slug: string | null | undefined): ScoreMovementList | null =>
  LISTS.find((l) => l.slug === (slug ?? '').trim().toLowerCase())?.slug ?? null;
